var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMyAccountIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EFF2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7334 21.3333C11.7334 20.2017 12.1829 19.1165 12.9831 18.3163C13.7832 17.5162 14.8685 17.0666 16.0001 17.0666C17.1317 17.0666 18.2169 17.5162 19.0171 18.3163C19.8172 19.1165 20.2667 20.2017 20.2667 21.3333H19.2001C19.2001 20.4846 18.8629 19.6707 18.2628 19.0706C17.6627 18.4704 16.8488 18.1333 16.0001 18.1333C15.1514 18.1333 14.3374 18.4704 13.7373 19.0706C13.1372 19.6707 12.8001 20.4846 12.8001 21.3333H11.7334ZM16.0001 16.5333C14.2321 16.5333 12.8001 15.1013 12.8001 13.3333C12.8001 11.5653 14.2321 10.1333 16.0001 10.1333C17.7681 10.1333 19.2001 11.5653 19.2001 13.3333C19.2001 15.1013 17.7681 16.5333 16.0001 16.5333ZM16.0001 15.4666C17.1787 15.4666 18.1334 14.512 18.1334 13.3333C18.1334 12.1546 17.1787 11.2 16.0001 11.2C14.8214 11.2 13.8667 12.1546 13.8667 13.3333C13.8667 14.512 14.8214 15.4666 16.0001 15.4666Z",
    fill: "#19305A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMyAccountIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/myAccountIcon.b930613b.svg";
export { ForwardRef as ReactComponent };